import React from 'react'
import TableCell from '@mui/material/TableCell'

export default function generate({ t }) {
  return [
    {
      name: 'nParc',
      label: t('common.nParc'),
      options: {
        sort: true,
        customHeadRender: () => {
          return (
            <TableCell
              key="nParc-translation"
              style={{ fontWeight: 'bolder', fontSize: 12 }}
            >
              {t('common.nParc')}
            </TableCell>
          )
        },
      },
    },
    {
      name: 'nChassis',
      label: t('common.chassis'),
      options: {
        sort: true,
        customHeadRender: () => {
          return (
            <TableCell
              key="nChassis-translation"
              style={{ fontWeight: 'bolder', fontSize: 12 }}
            >
              {t('common.chassis')}
            </TableCell>
          )
        },
      },
    },
    {
      name: 'interruptedAt',
      label: t('controls-detail.interrupted-at'),
      options: {
        sort: true,
        customHeadRender: () => {
          return (
            <TableCell
              key="interruptedAt-translation"
              style={{ fontWeight: 'bolder', fontSize: 12 }}
            >
              {t('controls-detail.interrupted-at')}
            </TableCell>
          )
        },
      },
    },
    {
      name: 'nonConformitiesCount',
      label: t('controls-detail.non-conformities-count'),
      options: {
        sort: true,
        customHeadRender: () => {
          return (
            <TableCell
              key="nonConformitiesCount-translation"
              style={{ fontWeight: 'bolder', fontSize: 12 }}
            >
              {t('controls-detail.non-conformities-count')}
            </TableCell>
          )
        },
      },
    },
    {
      name: 'controlledPoints',
      label: t('controls-detail.controlled-points'),
      options: {
        sort: false,
        customHeadRender: () => {
          return (
            <TableCell
              key="controlledPoints-translation"
              style={{ fontWeight: 'bolder', fontSize: 12 }}
            >
              {t('controls-detail.controlled-points')}
            </TableCell>
          )
        },
      },
    },
    {
      name: 'interruptedByUserName',
      label: t('controls-detail.interrupted-by'),
      options: {
        sort: false,
        customHeadRender: () => {
          return (
            <TableCell
              key="interruptedByUser-translation"
              style={{ fontWeight: 'bolder', fontSize: 12 }}
            >
              {t('controls-detail.interrupted-by')}
            </TableCell>
          )
        },
      },
    },
  ]
}
